import { Box, Stack } from '@mui/material';

export const GameHeader = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 150, // mora postojati visina da elementi imaju prostor
        background: 'linear-gradient(180deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        pt: 0,
        zIndex: 5,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          component="img"
          src="/crvena ribica.svg"
          alt="Whale mascot"
          sx={{
            width: 190,
            height: 40,
            objectFit: 'contain',
            position: 'relative',
            top: 40, // 🔥 ovo pomjera ribicu dole
          }}
        />
      </Stack>
    </Box>
  );
};
